export class Availability{
    constructor(obj){
        if(!obj){
            return;
        }
        this.startTime = new Date(obj.startTime);
        this.endTime = new Date(obj.endTime);
        this.age = obj.age;
        this.localisation = obj.localisation;
        this.carCategories = obj.carCategories;
    }
}
